import { useMemo } from 'react';
import styled from 'styled-components';
import { Box, LabelRegular } from '@comeon/ui';
import { AnimatePresence, motion } from 'framer-motion';
import WeSpinToggleSwitch from '../components/we-spin-toggle-switch.js';

const Container = styled(Box)`
	background: var(--we-spin-dashboard-container-bg);
	position: relative;
	border-radius: 3px;
`;

const SwitchDescription = styled(LabelRegular)`
	color: var(--we-spin-dashboard-switch-description-color);
	font: var(--caption);
	text-align: center;
	padding-bottom: 0;
`;

const WeSpinGameRoomFollowStreamerSwitch = ({
	isStreamerFollowed,
	onChangeStreamerFollowed,
	streamerName,
	translations
}) => {
	const label = useMemo(() => {
		return `${translations.WE_SPIN_FOLLOW_STREAMER_FOLLOW} ${streamerName}`;
	}, [streamerName, translations]);

	return (
		<Box display="flex" flexDirection="column">
			<Container p={5}>
				<WeSpinToggleSwitch label={label} isActive={isStreamerFollowed} onSwitch={onChangeStreamerFollowed} />
			</Container>
			<AnimatePresence>
				{!isStreamerFollowed && (
					<motion.span
						initial="open"
						animate="open"
						exit="collapsed"
						variants={{
							open: { height: 'auto', y: 0, opacity: 1 },
							collapsed: { height: '0px', y: -10, opacity: 0 }
						}}
					>
						<SwitchDescription my={1} p={5}>
							{translations.WE_SPIN_FOLLOW_STREAMER_CAPTION}
						</SwitchDescription>
					</motion.span>
				)}
			</AnimatePresence>
		</Box>
	);
};

export default WeSpinGameRoomFollowStreamerSwitch;
